<template>
	<div :class="['option-explanation', `option-explanation--${pageMode}`]">
		<div v-for="(option, index) in options" :key="index">
			<h3>
				<span>{{ option.title }}</span>
			</h3>
			<div>
				<p v-if="pageMode == 'suppliers'" v-html="option.supDescription"></p>
				<p v-if="pageMode == 'managers'" v-html="option.manDescription"></p>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: "OptionsExplanation",
	props: {
		pageMode: {
			type: String,
			default: "managers",
		},
	},
	data: () => ({
		options: [
			{
				title: "Roast Samples",
				supDescription: `Get samples of <strong>1850<sup>®</sup></strong>, <strong>Folgers<sup>®</sup></strong> and <strong>Café Bustelo<sup>®</sup></strong> roasts with a tasting guide to seal the sale.`,
				manDescription: `Get samples of <strong>1850<sup>®</sup></strong>, <strong>Folgers<sup>®</sup></strong> and <strong>Café Bustelo<sup>®</sup></strong> roasts to conduct a tasting with your employees.`,
			},
			{
				title: "Sweetener Rebate",
				supDescription: `Buy one case of employee-loved coffee, get a case of sweetener dispenser packs for free.`,
				manDescription: `Buy one case of coffee, get a free case of sweeteners!`,
			},
		],
	}),
};
</script>

<style lang="scss">
.option-explanation {
  & > div {
    border: 1px solid #707070;
    border-top: none;
    margin-bottom: 2em;
    margin-top: 2em;
    h3 {
      display: flex;
      align-items: flex-start;
			margin: 0;
      span {
        flex: 1 0 auto;
        padding: 0 0.5em;
        position: relative;
        top: -0.666em;
      }
      &::before, &::after {
        content: '';
        flex: 0 1 auto;
        display: block;
        width: 100%;
        /* width: auto; */
        height: 1px;
        background-color: #707070;
      }
    }
		& > div {
			height: calc(100% - 1em);
			position: relative;
			top: -0.666em;
			display: flex;
			flex-direction: column;
			justify-content: center;
			/* background-color: pink; */
			p {
				margin: 0.5em;
			}
		}
  }
}

.option-explanation--managers {
	@include breakpoint(large) {		
		display: flex;
		gap: 1em;
		& > div {
			flex: 0 0 calc(50% - 0.5em);
		}
	}
}
</style>